exports.components = {
  "component---src-templates-case-study-adapter-js": () => import("./../../../src/templates/case-study/adapter.js" /* webpackChunkName: "component---src-templates-case-study-adapter-js" */),
  "component---src-templates-page-adapter-js": () => import("./../../../src/templates/page/adapter.js" /* webpackChunkName: "component---src-templates-page-adapter-js" */)
}

